var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function extractPalette(tokenObject, mappedObject) {
    if (mappedObject === void 0) { mappedObject = {}; }
    var result = mappedObject;
    var processToken = function (group, token) {
        var formattedToken = token.toLowerCase().replace(/ /g, '');
        var tokenData = tokenObject.global[group][token];
        if (token in tokenObject.global[group] && typeof tokenData !== 'string') {
            var groupTokens = Object.keys(tokenData).reduce(function (acc, tokenKey) {
                var _a;
                var value = tokenData[tokenKey].value;
                return __assign(__assign({}, acc), (_a = {}, _a[tokenKey] = value, _a));
            }, {});
            result[formattedToken] = __assign(__assign({}, mappedObject[formattedToken]), groupTokens);
        }
        else {
            result[formattedToken] = tokenData;
        }
    };
    var processGroup = function (group) {
        Object.keys(tokenObject.global[group]).forEach(function (token) { return processToken(group, token); });
    };
    Object.keys(tokenObject.global).forEach(processGroup);
    return result;
}
export function getPaletteFromJson(tokenObject, isDarkMode) {
    if (isDarkMode === void 0) { isDarkMode = false; }
    var paletteTokens = extractPalette(tokenObject);
    var palette = __assign({ mode: isDarkMode ? 'dark' : 'light' }, paletteTokens);
    // (palette as PaletteOptions).mode = isDarkMode ? 'dark' : 'light';
    // Return parsed figma colors etc
    return palette;
}
